import React, { useEffect, useState } from "react";
import axios from "axios";
import ReferralTree from "./ReferralTree";
import API from "../api/api";
export default function TreePage() {
  const [treeData, setTreeData] = useState(null);

  useEffect(() => {
    const fetchTree = async () => {
      try {
        const res = await API.get("/api/users/tree", { withCredentials: true });
        if (res.data.success) {
          setTreeData(res.data.tree);
        }
      } catch (err) {
        console.error("Error fetching tree:", err);
      }
    };
    fetchTree();
  }, []);

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Referral Network Tree</h3>
      <ReferralTree data={treeData} />
    </div>
  );
}
